import axios from 'axios'
import { handleApiError } from './errorHandler'
import { getApiConfig } from '@/config/api'
import { getStorage } from '@/utils/storage'

const request = axios.create({
  baseURL: getApiConfig().baseUrl,
  timeout: getApiConfig().timeout,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 添加 APIkey
request.interceptors.request.use(
  (config) => {
    const apikey = getStorage('apikey')
    if (apikey) {
      config.headers.Authorization = `Bearer ${apikey}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器 - 统一错误处理
request.interceptors.response.use(
  (response) => {
    const { code, data, message } = response.data
    if (code === 0 || code === 200) {
      return data
    }
    handleApiError(code, message)
    return Promise.reject(new Error(message))
  },
  (error) => {
    handleApiError(error.response?.status, error.message)
    return Promise.reject(error)
  }
)

export default request
